import { render, staticRenderFns } from "./TeacherDashboardTherapistAddAccount.vue?vue&type=template&id=a37f6a38&scoped=true"
import script from "./TeacherDashboardTherapistAddAccount.vue?vue&type=script&lang=ts"
export * from "./TeacherDashboardTherapistAddAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37f6a38",
  null
  
)

export default component.exports